import type { UmbLocalizationDictionary } from '@umbraco-cms/backoffice/localization-api';

export default {
  auth: {
    continue: 'Doorgaan',
    validate: 'Valideren',
    login: 'Inloggen',
    email: 'Voer jouw e-mailadres in',
    username: 'Gebruikersnaam',
    password: 'Wachtwoord',
    submit: 'Verstuur',
    required: 'Verplicht',
    success: 'Succes',
    forgottenPassword: 'Wachtwoord vergeten?',
    forgottenPasswordInstruction: 'Er zal een e-mail worden gestuurd naar het e-mailadres van jouw account. Hierin staat een link om je wachtwoord te resetten',
    requestPasswordResetConfirmation: 'Een e-mail met daarin de wachtwoord reset uitleg zal worden gestuurd als het e-mailadres in onze database voorkomt.',
    setPasswordConfirmation: 'Je wachtwoord is aangepast',
    rememberMe: 'Onthoud mij',
    error: 'Fout',
    defaultError: 'Er is een onbekende fout opgetreden.',
    errorInPasswordFormat: 'Het wachtwoord moet minstens %0% tekens lang zijn en moet minstens %1% cijfers bevatten',
    passwordMismatch: 'Beide wachtwoorden zijn niet hetzelfde!',
    passwordMinLength: 'Je wachtwoord moet minstens {0} tekens lang zijn.',
    passwordIsBlank: 'Je nieuwe wachtwoord mag niet leeg zijn!',
    userFailedLogin: 'Oeps! We konden je niet inloggen. Controleer je inloggegevens en probeer het opnieuw.',
    userLockedOut: 'Je account is geblokkeerd. Probeer het later opnieuw.',
    receivedErrorFromServer: 'Een error ontvangen van de server',
    resetCodeExpired: 'De link die je hebt aangeklikt is niet (meer) geldig.',
    userInviteWelcomeMessage: 'Hallo en welkom in Umbraco! Binnen ongeveer één minuut kan je aan de slag. Je moet enkel je wachtwoord instellen.',
    userInviteExpiredMessage: 'Welkom bij Umbraco! Helaas is je uitnodiging vervallen. Vraag aan je administrator om de uitnodiging opnieuw te versturen.',
    newPassword: 'Wijzig je wachtwoord',
    confirmNewPassword: 'Bevestig nieuw wachtwoord',
    greeting0: 'Welkom',
    greeting1: 'Welkom',
    greeting2: 'Welkom',
    greeting3: 'Welkom',
    greeting4: 'Welkom',
    greeting5: 'Welkom',
    greeting6: 'Welkom',
    mfaTitle: 'Laatste stap!',
    mfaCodeInputHelp: 'Vul de verificatiecode in',
    mfaText: 'Je hebt tweestapsverificatie ingeschakeld en moet je identiteit verifiëren.',
    mfaMultipleText: 'Kies een tweestapsverificatie aanbieder',
    mfaCodeInput: 'Verificatiecode',
    mfaInvalidCode: 'Ongeldige code ingevoerd',
    signInWith: 'Inloggen met {0}',
    returnToLogin: 'Terug naar loginformulier',
    localLoginDisabled: 'Helaas is direct inloggen niet mogelijk. Het is uitgeschakeld door een aanbieder.',
    friendlyGreeting: 'Hallo!',
  },
} satisfies UmbLocalizationDictionary;
